import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { PortableText } from "@portabletext/react";
import { sanityClient } from "../../sanityClient";
import { sanityPortableTextComponents } from "../components/sanityPortableTextComponents";

const HeroBanner = styled("div")(({ theme }) => ({
  backgroundColor: "#FAE2CF",
  borderBottomLeftRadius: "24px",
  [theme.breakpoints.up(768)]: {
    borderBottomLeftRadius: "50px",
  },
}));

const CategoryTitle = styled("div")(({ theme }) => ({
  color: "#000 !important",
  fontSize: "32px !important",
  lineHeight: "1.2 !important",
  whiteSpace: "normal !important",
  fontFamily: "Helvetica Bold, sans-serif !important",
  fontWeight: "bold !important",
  margin: "0 0 1rem 0 !important",
  display: "block !important",
  textTransform: "none !important",
  [theme.breakpoints.up(768)]: {
    fontSize: "65px !important",
  },
  "&&&": {
    fontSize: "32px !important",
    [theme.breakpoints.up(768)]: {
      fontSize: "65px !important",
    },
  },
}));

const BecomeASellerText = ({ becomeASeller }) => {
  return (
    <div className="container-lg">
      <div className="mb-3">
        <h2>{becomeASeller.title}</h2>
      </div>
      {becomeASeller?.body && (
        <PortableText
          value={becomeASeller.body}
          components={sanityPortableTextComponents}
        />
      )}
    </div>
  );
};

const BecomeASeller = () => {
  const [becomeASeller, setBecomeASeller] = useState(null);

  const getBecomeASeller = async () => {
    const query = `*[_type == "becomeASeller"] | order(sort asc) {
      _id,
      title,
      body
    }`;
    const data = await sanityClient.fetch(query);
    if (data?.length > 0) {
      setBecomeASeller(data[0]);
    } else {
      setBecomeASeller(null);
    }
  };

  useEffect(() => {
    getBecomeASeller();
  }, []);

  return (
    <>
      <section className="my-4 my-md-5 px-3">
        <HeroBanner className="container-lg px-0">
          <div className="row g-0">
            <div className="col-md-6 offset-md-1 px-3">
              <div className="py-4 py-md-5">
                <CategoryTitle className="mb-3">Become A Seller</CategoryTitle>
                <p>
                  Learn how to sell mockups on Mockee and grow with our creator
                  community.
                  <br />
                </p>
              </div>
            </div>
            <div className="col-md-5 px-0">
              <div
                className="h-100 d-flex justify-content-end"
                style={{ paddingRight: "30px" }}
              >
                <img
                  src="/assets/images/become_a_seller.svg"
                  alt="Become A Seller"
                  className="img-fluid h-100 mb-hidden object-fit-cover"
                  style={{
                    borderTopLeftRadius: "60px",
                    width: "55%",
                    objectFit: "contain",
                    objectPosition: "right center",
                    transform: "scaleX(-1)",
                  }}
                />
              </div>
            </div>
          </div>
        </HeroBanner>
      </section>
      <section className="terms-use py-4 py-md-5">
        {becomeASeller && (
          <BecomeASellerText becomeASeller={becomeASeller} />
        )}
      </section>
    </>
  );
};

export default BecomeASeller;
